import { IDefaultSpaAgreementPayload } from 'quotes/types';
import { IPricingFieldMapping } from 'quotes/utils';

export const externalSpaCostSourceFields: IPricingFieldMapping[] = [
  { field: 'costSourceType', mapTo: 'sourceType' },
  { field: 'externalSpaCostSource' },
  { field: 'externalSpaCostSourceName' },
  { field: 'externalSpaCostRegistrationNum' },
  { field: 'externalSpaCostEndDate' },
  { field: 'externalSpaCost' },
];

export const externalSellPriceSourceFields: IPricingFieldMapping[] = [
  { field: 'priceSourceType', mapTo: 'sourceType' },
  { field: 'externalSellPriceSource' },
  { field: 'externalSellPriceSourceName' },
  { field: 'externalSellPriceEndDate' },
];

// The BE leaves all five out of an answer for a pick, so they keep describing the default.
export const defaultSpaAgreementFields: (keyof IDefaultSpaAgreementPayload)[] = [
  'externalSpaCost',
  'externalSpaCostEndDate',
  'externalSpaCostRegistrationNum',
  'externalSpaCostSource',
  'externalSpaCostSourceName',
];
